import { GaugeWidget } from "../gauge_widget";
import withThingStateAggregations from "components/widget/observation_hocs/with_thing_state_aggregations";

export default withThingStateAggregations(GaugeWidget);
